module.exports = __webpack_public_path__ + "img/downarrow-40adeddf.svg";